import { render, staticRenderFns } from "./menu-dept.vue?vue&type=template&id=731ad0ee&scoped=true"
import script from "./menu-dept.vue?vue&type=script&lang=js"
export * from "./menu-dept.vue?vue&type=script&lang=js"
import style0 from "./menu-dept.vue?vue&type=style&index=0&id=731ad0ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ad0ee",
  null
  
)

export default component.exports